import moment from 'moment';
const strDt = moment().startOf('month').format('YYYY-MM-DD');
const endDt = moment().endOf('month').format('YYYY-MM-DD');

export default {
	isSaved: false,
	resultList: [],
	resultList2: {},
	jgmtReslutList: JGMT_RESULT_DATA(), //단품판정결과 목록
	selectedRow: SELECTED_ROW(),
	searchParams: SEARCH_PARAMS(),
	searchDtlParams: SEARCH_DTL_PARAMS(),
	stateParams: STATE_PARAMS(), // 승인 Process관련
	reInsPopupParams: RE_INS_POPUP_PARAMS(), // 재검사 파라미터

	partClCdList: [], //유형(초도품, 초기양산, 양산, 변경품) selectBox
	ovrlJgmtCdList: [], //종합판정(합격/불합격/결품) selectBox
	ckuClCdList: [], //검사분류 selectBox
	ckuScnCdList: [], //검사구분(LOT/SERIAL) selectBox
	ckuPrvsCdList: [], //검사항목 selectBox
	ckuWayCdList: [], //검사방법 selectBox
	passDsqfCdList: [], //합불기준 selectBox (사용안할예정)
	indvJgmtCdList: [], //합불기준 selectBox
	pgsStPcCdList: [], //검사상태 selectBox
	resultPopupList: [],

	formInfo: FORM_DATA(),

	pagingInfo: PAGING_INFO(),

	searchCommParams: SEARCH_COMM_PARAMS(),
	resultPopupCommList: [],
	searchBarcodeResult: SEARCH_BARCODE_RESULT()
};

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 10,
		startPage: 1,
		totalSize: 1
	};
}

function FORM_DATA() {
	return {
		partNo: '', //부품번호
		partNm: '', //부품명
		ckuNo: '', //검사번호
		altrNo: '', //변경번호
		tymaCd: '', //기종코드
		cofCd: '', //협력업체코드
		cofNm: '', //협력업체명
		lotFromNo: '', //로트 시작번호
		lotToNo: '', //로트 종료번호
		bcdLblId: '', //바코드라벨ID
		ckuClCd: '', //검사분류코드
		ckuScnCd: '', //검사구분코드
		orderNo: '', //orderNo
		ckurId: '', //검사자ID
		ckuDd: '', //검사일
		ckuStrtDt: '', //검사시작일시
		ckuEndDt: '', //검사종료일시
		ckuQty: '', //검사수량
		badQty: '', //불량수량
		partClCd: '', //부품분류코드
		rprYn: '', //리페어여부
		ovrlJgmtCd: '', //종합판정코드
		pgsStCd: '', //진행상태코드
		affrPrcsId: '', //업무처리ID
		affrDspoId1: '', //작성자
		affrDspoNm1: '', //작성자명
		affrPrcsDt1: '', //작성일
		affrDspoId2: '', //승인자
		affrDspoNm2: '', //승인자명
		affrPrcsDt2: '', //승인일
		rmk: '', //비고
		rmkHis: '', // 비고이력
		partCkuFileId: '', //불량파일ID
		partCkuFile: [], //불량파일 목록
		partCkuFileDb: [] //db에서 받는 파일 정보
	};
}

function SELECTED_ROW() {
	return {
		overSrgNo: '',
		rgnId: '',
		badSbc: '',
		badClCd: '',
		badScnCd: '',
		partNo: '',
		partNm: '',
		occuDd: '',
		powCd: '',
		occuQty: ''
	};
}

function SEARCH_PARAMS() {
	return {
		partNo: '',
		ckuNo: '',
		cofCd: '',
		cofNm: '',
		strDt,
		endDt,
		bcdLblId: '', //바코드라벨
		bcdPartNo: '', //바코드품번
		partClCd: '', //부품분류코드
		ckdYn: 'N', //역순조회
		speYn:	'N'
	};
}

function SEARCH_DTL_PARAMS() {
	return {
		partNo: '',
		ckuNo: '',
		cofCd: '',
		cofNm: '',
		strDt,
		endDt
	};
}

function STATE_PARAMS() {
	return {
		partNo: '',
		ckuNo: '',
		affrPrcsId: '',
		pgsStCd: '',
		rmk: ''
	};
}

function JGMT_RESULT_DATA() {
	return {
		x1: '',
		x2: '',
		x3: '',
		x4: '',
		x5: '',
		x6: '',
		x7: '',
		x8: '',
		x9: '',
		x10: ''
	};
}

function SEARCH_COMM_PARAMS() {
	return {
		partNo: ''
	};
}

function RE_INS_POPUP_PARAMS() {
	return {
		partNo: '',
		ckuNo: '',
		partNm: '',
		reInsQty: ''
	};
}

function SEARCH_BARCODE_RESULT() {
	return {
		bcdLblId: '',
		partNo: '',
		ckuNo: '',
		lotFromNo: '',
		lotToNo: '',
		cofCd: '',
		cofNm: '',
		resultYn: ''
	};
}

export {
	FORM_DATA,
	SEARCH_PARAMS,
	SELECTED_ROW,
	STATE_PARAMS,
	JGMT_RESULT_DATA,
	PAGING_INFO,
	SEARCH_DTL_PARAMS,
	SEARCH_COMM_PARAMS,
	RE_INS_POPUP_PARAMS,
	SEARCH_BARCODE_RESULT
};
